module.exports = __webpack_public_path__ + "img/voideBg2.654ef91b.jpg";